import type MastResultDto from "../../../../dto/calculations/MastResultDto";
import type ICalculationConstructionDetailsNewProps from "./ICalculationConstructionDetailsNewProps";
import styles from "./calculationConstructionDetailsNew.module.scss";
import CalculationConstructionNewField from "./field/CalculationConstructionNewField";
import DrillholesCodeNewField from "./field/drillholescode/DrillholesCodeNewField";

const CalculationConstructionDetailsNew: React.FunctionComponent<ICalculationConstructionDetailsNewProps> = ({
    input,
    selectedMastNumber,
    calculationResults
}) => {
    const selectedMast = input.masts?.find(m => m.number === selectedMastNumber);
    const {
        profile,
        foundationType,
        foundationAdditionalDepth,
        foundationMastLength,
        drillholesCode,
    } = calculationResults?.mastResults?.find((mr: MastResultDto) => mr.mastNo === selectedMastNumber) ?? {};
    const {calculationId} = calculationResults ?? {};

 return (
    <div className={`${styles.infoContainer} page-brake-after`}>
      <div className={styles.infoBox}>
        <CalculationConstructionNewField label="Mast profile" value={profile} />
        <CalculationConstructionNewField label="Mast length" value={selectedMast?.length} />
        <CalculationConstructionNewField label="Mast leveling" value={selectedMast?.leveling} />
        <CalculationConstructionNewField label="Mast Reverse Deflection" value={selectedMast?.reverseDeflection}
        />
        <DrillholesCodeNewField
          label="Drillholes Code"
          selectedMast={selectedMast}
          calculationId={calculationId}
          drillholesCode={drillholesCode}
        />
      </div>
      <div className={styles.infoBox}>
        <CalculationConstructionNewField label="Foundation Type" value={foundationType} />
        <CalculationConstructionNewField label="Additional Depth of the Foundation" value={foundationAdditionalDepth} />
        <CalculationConstructionNewField label="Length of mast in the foundation" value={foundationMastLength} />
      </div>
    </div>
  );
};

export default CalculationConstructionDetailsNew;